import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

// Legacy route: sign-in links are now handled by the server (/api/auth/magic).
export default function VerifyMagic() {
  const navigate = useNavigate();
  useEffect(() => { navigate("/login?error=invalid", { replace: true }); }, [navigate]);
  return (
    <div data-testid="verify-magic" className="min-h-screen bg-[#FAF8F5] flex items-center justify-center">
      <Loader2 className="h-8 w-8 text-amber-800 animate-spin" />
    </div>
  );
}
